/* Rodier dots navigation */
(function() {
  function initDots(themeScroll) {
    var inner = themeScroll.querySelector('.multicolumn--inner') ||
                themeScroll.querySelector('.products.carousel');
    if (!inner) return;
    var slides = Array.from(inner.querySelectorAll(
      inner.classList.contains('multicolumn--inner') ? '.multicolumn--column' : '.carousel__slide'
    ));
    if (!slides.length) return;

    var dotsEl = document.createElement('div');
    dotsEl.className = 'multicolumn-dots';

    slides.forEach(function(_, i) {
      var dot = document.createElement('button');
      dot.className = 'multicolumn-dots__dot';
      dot.setAttribute('aria-label', 'Slide ' + (i + 1));
      dot.addEventListener('click', function() {
        inner.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      });
      dotsEl.appendChild(dot);
    });

    themeScroll.insertAdjacentElement('afterend', dotsEl);

    function updateDots() {
      var active = Math.round(inner.scrollLeft / inner.offsetWidth);
      dotsEl.querySelectorAll('.multicolumn-dots__dot').forEach(function(dot, i) {
        dot.classList.toggle('is-active', i === active);
      });
    }

    inner.addEventListener('scroll', updateDots, { passive: true });
    updateDots();
  }

  document.querySelectorAll('.multicolumn--dots-nav theme-scroll').forEach(initDots);
  document.querySelectorAll('theme-scroll.rodier-dots-nav').forEach(initDots);
})();

/* Sizing guide drawer */
document.querySelectorAll('.sizing-guide-drawer').forEach(function(drawer) {
	document.body.appendChild(drawer);
});

document.addEventListener('click', function(e) {
	var btn = e.target.closest('[data-sizing-drawer]');
	if (!btn) return;
	var drawer = document.querySelector(btn.dataset.sizingDrawer);
	if (!drawer) return;
	drawer.classList.add('active');
	drawer.removeAttribute('inert');
	drawer.removeAttribute('aria-hidden');
	document.body.classList.add('open-cc', 'overflow-hidden');
});

/* Complementary products — size pre-selection */
(function() {
  var selectedOptions = {};

  function escapeAttr(str) {
    return str.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function captureOptions(container) {
    container.querySelectorAll('input[type=radio]:checked').forEach(function(input) {
      var name = input.name.replace(/--sticky$/, '');
      selectedOptions[name] = input.value;
    });
    container.querySelectorAll('select').forEach(function(select) {
      var match = select.name.match(/^options\[(.+?)(?:--sticky)?\]$/);
      if (match) selectedOptions[match[1]] = select.value;
    });
  }

  function applyOptions(drawerContent) {
    var vs = drawerContent.querySelector('variant-selects');
    if (!vs) return;
    Object.keys(selectedOptions).forEach(function(optionName) {
      var value = selectedOptions[optionName];
      var escaped = escapeAttr(optionName);
      var escapedVal = escapeAttr(value);

      var radio = vs.querySelector('input[type=radio][name="' + escaped + '"][value="' + escapedVal + '"]');
      if (radio && !radio.checked) {
        radio.click();
        return;
      }

      var sel = vs.querySelector('select[name="options[' + escaped + ']"]');
      if (sel && sel.querySelector('option[value="' + escapedVal + '"]')) {
        sel.value = value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  document.addEventListener('change', function(e) {
    var vs = e.target.closest('variant-selects');
    if (!vs) return;
    if (vs.closest('#Product-Drawer')) return;
    captureOptions(vs);
  });

  function initCapture() {
    var vs = document.querySelector('variant-selects:not(#Product-Drawer variant-selects)');
    if (vs) captureOptions(vs);
  }

  if (customElements.get('variant-selects')) {
    initCapture();
  } else {
    document.addEventListener('DOMContentLoaded', initCapture);
  }

  document.addEventListener('quick-view:open', function() {
    setTimeout(function() {
      var content = document.getElementById('Product-Drawer-Content');
      if (content) applyOptions(content);
    }, 80);
  });
})();